import { useEffect, useState } from 'react'
import { PdfViewer, PdfViewerHeightWorkaround } from '@sequencehq/pdf-viewer'

type Props = {
  url: string
  fileName: string
  'data-testid'?: string
  children?: React.ReactNode
}

export const AttachmentPdfPreview = ({
  url,
  fileName,
  'data-testid': dataTestId,
  children
}: Props) => {
  const [data, setData] = useState<Blob | undefined>()

  useEffect(() => {
    const fetchUrl = async () => {
      const res = await fetch(url)
      const blob = await res.blob()
      const pdfBlob = blob.slice(0, blob.size, 'application/pdf')
      setData(pdfBlob)
    }

    void fetchUrl()
  }, [url])

  if (!data) {
    return null
  }

  return (
    <PdfViewerHeightWorkaround>
      <PdfViewer data={data} fileName={fileName} data-testid={dataTestId}>
        <PdfViewer.StandardControls />
        {children}
      </PdfViewer>
    </PdfViewerHeightWorkaround>
  )
}
